export default __webpack_public_path__ + "static/media/Panjeree-1.4afed62d.png";